const allColors = [
    [
        "#000000",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#00D9A5",
    ],
    [
        "#000000",
        "#3347B0",
        "#E8B4E7",
        "#CCF6E8",
    ],
    [
        "#000000",
        "#ffbf6e",
        "#a6d40d",
        "#651300",
    ],
    [
        "#000000",
        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ],
    [
        "#000000",
        "#00d973",
        "#fa2b00",
        "#0000ff",
    ],
    [
        "#000000",
        "#fefcfb",
    ],
    [
        "#000000",
        "blue",
    ],
    [
        "#000",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
    ],
    [
        "#000",
        "#8c6510",
        "#ffb852",
    ],
    [
        "#000",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#2A1F1D",
        "#7A999C",
        "#475B62",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000",
        "blue",
        "#2619d1",
        // "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#000",
        "#3BB487",
        "#E6393B",
        "#EC6DA4",
        "#777CBC",
    ],
    [
        "#000",
        "#6D262A",
        "#C6422B",
        "#00A86D",
        "#024633",
        "#038DB2",
        "#CA1D2A",
    ],

    [
        "#000",
        "#111",
        "#222",
        "#333",
        "#555",
        "#888",
        "#aaa",
        "#bbb",
        "#ddd",
    ]


]
export default allColors